import axios from 'axios';
import { Service } from 'axios-middleware';

export const service = new Service(axios);
const url = process.env.REACT_APP_URL

service.register({
  onRequest(config: any) {
    if (config.url.includes("datakeen-hiris.s3")) {
      return config
    }
    if (config.url.includes(url + "/user/auth" || config.url.includes("datakeen-hiris.s3"))) {
      return config;
    } else {
      const tokens = localStorage.getItem("token")
      if (tokens) {
        const token = JSON.parse(tokens)
        config.headers.Authorization = "Bearer " + token.accessToken
      }
      return config
    }
  },
  onSync(promise: any) {
    return promise;
  },
  onResponse(response: any) {
    return response;
  }
});


axios.interceptors.response.use(function (response) {
  return response;
}, async function (error) {
  if (error.response.status === 403) {
    // window.location.replace(window.location.host + "/login");
  }
  return Promise.reject(error);
});